import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { url_ws } from 'src/app/config/config';


@Injectable({
  providedIn: 'root'
})
export class UploadService {

  public url = url_ws;
  constructor(private http: HttpClient) { }

  uploadFiles(file: File, id: string) {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    // headers.append('Content-Type','application/json');

    let formData: FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id', id);
    //console.log(file.name);

    return this.http.post(this.url + "fileUpload.php", formData, { headers: headers }).pipe(map(data => {
      return data;
    }));
  }

  uploadFilesgeneric(file: File, id: string, folder: string, database: string, field: string) {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    // headers.append('Content-Type','application/json');

    let formData: FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id', id);
    formData.append('folder', folder);
    formData.append('database', database);
    formData.append('field', field);
    //console.log(file.name);

    return this.http.post(this.url + "fileupload/fileUploadGeneric.php", formData, { headers: headers }).pipe(map(data => {
      return data;
    }));
  }
  deleteFilesGeneric(id: string, folder: string, database: string, field: string) {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    // headers.append('Content-Type','application/json');

    let formData: FormData = new FormData();

    formData.append('id', id);
    formData.append('folder', folder);
    formData.append('database', database);
    formData.append('field', field);
    //console.log(file.name);

    return this.http.post(this.url + "fileupload/fileDeleteGeneric.php", formData, { headers: headers }).pipe(map(data => {
      return data;
    }));
  }

  /**
   * 
   * Que tipo es 
   *  
   * @param {File} file
   * @param {string} id
   * @param {string} folder
   * @param {string} database
   * @param {string} field
   * @param {string} tipo
   * @returns
   * @memberof UploadService
   */

}
